import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  lineup: null,
  firstLineUpFetchLoading: false,
  secondLineUpFetchLoading: false,
  firstTeamLineUp: null,
  secondTeamLineUp: null,
};

const slice = createSlice({
  name: "lineup",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    stopLoading(state) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.firstLineUpFetchLoading = false;
      state.secondLineUpFetchLoading = false;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },

    startFirstLineUpFetchLoading(state) {
      state.firstLineUpFetchLoading = true;
    },

    startSecondLineUpFetchLoading(state) {
      state.secondLineUpFetchLoading = true;
    },
    // UPDATE EVENT
    updateSquadSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.sqauds = state.sqauds.map((squad) => {
        if (squad.id === action.payload.id) {
          return action.payload;
        }
        return squad;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.error = action.payload;
    },

    // GET PRODUCTS

    getFirstLineUpSuccess(state, action) {
      state.isLoading = false;
      state.firstLineUpFetchLoading = false;
      state.firstTeamLineUp = action.payload;
    },

    // GET PRODUCTS
    getSecondLineUpSuccess(state, action) {
      state.isLoading = false;
      state.secondLineUpFetchLoading = false;
      state.secondTeamLineUp = action.payload;
    },

    updateFirstLineUpSuccess(state, action) {
      state.isLoading = false;
      state.firstLineUpFetchLoading = false;
      state.firstTeamLineUp = action.payload.reverse();
    },

    updateSecondLineUpSuccess(state, action) {
      state.isLoading = false;
      state.secondLineUpFetchLoading = false;
      state.secondTeamLineUp = action.payload.reverse();
    },

    // GET PRODUCTS
    createFirstLineUpSuccess(state, action) {
      state.isLoading = false;
      state.firstLineUpFetchLoading = false;
      state.firstTeamLineUp = action.payload;
    },

    createSecondLineUpSuccess(state, action) {
      state.isLoading = false;
      state.secondLineUpFetchLoading = false;
      state.secondTeamLineUp = action.payload;
    },

    updateLineUpSuccess(state, action) {
      state.isLoading = false;
      state.firstLineUpFetchLoading = false;

      if (action.payload.isFirstTeam) {
        state.firstTeamLineUp = state.firstTeamLineUp.map((lineup) => {
          if (lineup.id === action.payload.data.id) {
            return { ...lineup, ...action.payload.data };
          } else {
            return lineup;
          }
        });
      } else {
        state.secondTeamLineUp = state.secondTeamLineUp.map((lineup) => {
          if (lineup.id === action.payload.data.id) {
            return { ...lineup, ...action.payload.data };
          } else {
            return lineup;
          }
        });
      }
    },

    // DELETE EVENT
    deleteSquadSuccess(state, action) {
      // const squadId = action.payload;
      // state.sqauds = state.sqauds.filter((team) => team.id !== squadId);
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getFirstLineUps({
  team_slug,
  game_slug,
  a,
  j,
  season_id,
  enqueueSnackbar,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startFirstLineUpFetchLoading());
    try {
      const response = await axios.get(
        `line-ups?team_id=${team_slug}&game_id=${game_slug}`,
        {
          params: {
            a,
            j,
            season_id,
          },
        }
      );
      dispatch(slice.actions.getFirstLineUpSuccess(response.data.data.data));
    } catch (error) {
      enqueueSnackbar && enqueueSnackbar(error.message, { variant: "error" });
      dispatch(slice.actions.stopLoading());
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSecondLineUps({
  team_slug,
  game_slug,
  a,
  j,
  season_id,
  enqueueSnackbar,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startSecondLineUpFetchLoading());
    try {
      const response = await axios.get(
        `line-ups?team_id=${team_slug}&game_id=${game_slug}`,
        {
          params: {
            a,
            j,
            season_id,
          },
        }
      );
      dispatch(slice.actions.getSecondLineUpSuccess(response.data.data.data));
    } catch (error) {
      enqueueSnackbar && enqueueSnackbar(error.message, { variant: "error" });
      dispatch(slice.actions.stopLoading());
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: update lineups
export function updateFirstLineUp({ data, enqueueSnackbar, setOpen }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("line-ups", data);

      dispatch(slice.actions.updateFirstLineUpSuccess(response.data.data));
      enqueueSnackbar("Line-up is updated successfully");
      setOpen(false);
      // navigate(-1);
    } catch (error) {
      setOpen(false);

      enqueueSnackbar(error.message || "error updating lineup", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateSecondLineUp({ data, enqueueSnackbar, setOpen }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("line-ups", data);

      dispatch(slice.actions.updateSecondLineUpSuccess(response.data.data));
      enqueueSnackbar("Line-up is updated successfully");
      setOpen(false);
      // navigate(-1);
    } catch (error) {
      setOpen(false);

      enqueueSnackbar(error.message || "error creating lineup", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createFirstLineUp({ data, enqueueSnackbar, setOpenConfirm }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("line-ups", data);
      dispatch(slice.actions.createFirstLineUpSuccess(response.data.data));
      enqueueSnackbar("Line-up is added successfully");
      setOpenConfirm(false);
      // navigate(-1);
    } catch (error) {
      setOpenConfirm(false);

      enqueueSnackbar(error.message || "error creating squad", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createSecondLineUp({ data, enqueueSnackbar, setOpenConfirm }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("line-ups", data);

      dispatch(slice.actions.createSecondLineUpSuccess(response.data.data));
      enqueueSnackbar("Line-up is added successfully");
      setOpenConfirm(false);
      // navigate(-1);
    } catch (error) {
      setOpenConfirm(false);

      enqueueSnackbar(error.message || "error creating squad", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: in match scoreboard

export function updatePlayerInMatch({
  data,
  enqueueSnackbar,
  lineup_id,
  isFirstTeam,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axios.patch(`line-ups/${lineup_id}`, data);
      dispatch(
        slice.actions.updateLineUpSuccess({
          data: response.data.data,
          isFirstTeam,
        })
      );
    } catch (error) {
      enqueueSnackbar(error.message || "network error", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteLineUp({
  team_slug,
  game_slug,
  enqueueSnackbar,
  lineup_id,
  isFirstTeam,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      await axios.delete(`line-ups/${lineup_id}`);
      if (isFirstTeam) {
        dispatch(getFirstLineUps({ team_slug, game_slug, season_id }));
      } else {
        dispatch(getSecondLineUps({ team_slug, game_slug, season_id }));
      }
    } catch (error) {
      enqueueSnackbar(error.message || "error deleting lineup", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}
